import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar'
import Home from './pages/Home'
import MovieDetail from './pages/MovieDetail'
import Policy from './pages/Policy'
import NotFound from './pages/NotFound'
import OldMovies from './pages/OldMovies'
import Profile from './pages/Profile'
import MissingMovieForm from './pages/MissingMovieForm';
import WatchlistPage from './pages/WatchlistPage';
import TrailersPage from './pages/TrailersPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const { loading } = useAuth()

  if (loading) {
    return (
      <HelmetProvider>
        <LoadingSpinner />
      </HelmetProvider>
    )
  }

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-background-light">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/movie/:slug" element={<MovieDetail />} />
            <Route path="/trailers" element={<TrailersPage />} />
            <Route path="/archive" element={<OldMovies />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/suggest-movie" element={<MissingMovieForm />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/watchlist"
              element={
                <ProtectedRoute>
                  <WatchlistPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  )
}

export default App
